export const ecmFrTranslation = {
    ecm: {
        shell: {
            'loading-text': 'Chargement en cours',
        },
        menu: {
            title: 'Espace client',
            button: 'Menu',
            sections: [
                {
                    label: 'Accueil',
                    path: 'accueil',
                },
                {
                    label: 'Infos Personnelles',
                    path: 'compte',
                },
            ],
            return: 'Retour',
        },
        survey: {
            'close-label': 'Fermer',
        },
        'native-app-update': {
            'title-orange': "Pour recharger, vous devez mettre à jour l'application Orange et moi.",
            'title-sosh': "Pour recharger, vous devez mettre à jour l'application MySosh.",
            'subtext-warning': "La version que vous utilisez n'est pas compatible avec le rechargement de forfait.",
            'subtext-info': 'Le rechargement reste disponible par téléphone en appelant le 740.',
            'confirmation-label': 'Mettre à jour',
        },
    },
};
